module.exports = __webpack_public_path__ + "img/id-card.4993a157.svg";